
export const tableHeaders = () => [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Firstname',
    intlKey: 'table.recipient_first_name'
  },
  {
    id: 3,
    label: 'Lastname',
    intlKey: 'table.recipient_last_name'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.recipient_email'
  },
  {
    id: 5,
    label: 'Message channel',
    intlKey: 'table.recipient_message_channel'
  },
  {
    id: 6,
    label: 'Read date',
    intlKey: 'table.recipient_read_date'
  }
]
